import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { useSeo } from "@/lib/useSeo";

export default function Legal({ pageKey }) {
  const { data: settings } = useQuery({ queryKey: ["settings"], queryFn: async () => (await api.get("/content/settings")).data });
  const page = settings?.legal?.[pageKey];
  useSeo({ title: page?.title || "Legal", description: `${page?.title || "Legal"} for Buddy Solution.` });

  return (
    <div className="bs-container py-16 lg:py-20">
      <div className="mx-auto max-w-3xl">
        <h1 className="font-display text-4xl font-black sm:text-5xl">{page?.title || "Legal"}</h1>
        <p className="mt-3 text-sm text-muted-foreground">Last updated: managed from the admin panel. This document reflects the features actually implemented on this platform.</p>
        <div className="mt-8 space-y-5">
          {(page?.content || "This document is being prepared.").split("\n\n").map((para, i) => (
            <p key={i} className="leading-relaxed text-foreground/90">{para}</p>
          ))}
        </div>
      </div>
    </div>
  );
}
